import {
  PreviewFinanceFinancialDocumentPreviewLineItemsInput,
  UpsertSaleFinanceFinancialDocumentComplianceExtraFieldsInput,
  UpsertSaleFinanceFinancialDocumentLineItemsInput,
} from 'generated/resources/graphql'

import { toCents } from 'modules/core/lib/formatCurrencyUtils'

import {
  FormComplianceExtraFields,
  LineItem,
} from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/SaleInvoiceForm/types'

export const mapLineItemsForUpsert = (
  lineItems: LineItem[]
): UpsertSaleFinanceFinancialDocumentLineItemsInput[] => {
  return lineItems
    .map((item) => {
      if (!item.quantity || !item.amount || !item.description || !item.taxRate?.id) {
        return null
      }
      return {
        description: item.description,
        quantity: item.quantity,
        amountCents: toCents(item.amount),
        taxRateId: item.taxRate.id,
        id: String(item.id),
      }
    })
    .filter((item) => item != null)
}

export const mapComplianceExtraFieldsForUpsert = (
  complianceExtraFields: FormComplianceExtraFields[],
  createCreditNote = false
): UpsertSaleFinanceFinancialDocumentComplianceExtraFieldsInput[] => {
  return complianceExtraFields
    .map((item) => {
      return {
        id: createCreditNote ? undefined : item.id,
        country: item.countryCode,
        organization: item.organization,
        fields: item.fields.map((field) => ({
          associatedFieldId: field.associatedFieldId,
          name: field.name,
          value: field.value,
        })),
      }
    })
    .filter((item) => item != null)
}

export const mapLineItemsForPreview = (
  lineItems: LineItem[]
): PreviewFinanceFinancialDocumentPreviewLineItemsInput[] => {
  return lineItems
    .map((item) => {
      return {
        description: item.description,
        quantity: item.quantity,
        amountCents: item.amount && toCents(item.amount),
        taxRateId: item.taxRate?.id,
      }
    })
    .filter((item) => item != null)
}
